import React from "react";
import { Typography, Grid, IconButton, CardContent, Box, CardActions } from "@mui/material";
import { MdChevronLeft } from "react-icons/md";
import GoogleMapReact from "google-map-react";
import { useParams } from "react-router-dom";
import PcpListItem from "./PcpListItem";
import { useHistory } from "react-router-dom";
import PcpLocationItem from "./PcpLocationItem";
import MapMarker from "./MapMarker";
import { PatientData } from "../../Contexts";
import * as CONST from "../../Constants";
import * as API from "../../api";
import Reducer from "../../Reducer";

export default function SelectedLocation(props) {
  let patient = props.patientData;
  let practice = props.pcp_practice;
  const history = useHistory();
  let { id } = useParams();

  React.useEffect(() => {
    (async () => {
      if (patient) {
        let practice;
        patient.pcps_by_practice && patient.pcps_by_practice.forEach((el) => {
          let prc = el.pcp_practices.find((el) => el.id == id);
          if (prc) {
            practice = prc;
          }
        });

        if (practice) {
          props.dispatch({
            type: "set_current_pcp_practice",
            payload: practice,
          });
        }
      }
    })();
  }, []);

  if (!practice) {
    return (<>
      Loading...
    </>);
  };

  return (
    <Grid container>
      <Grid item xs={12} className="bt">
        <CardActions disableSpacing pl={2} py={0} className="bb">
          <IconButton
            className="card-button"
            onClick={(e) => {
              history.push(`/patient_portal/pcp_election`);
            }}
            aria-label="back to our PCP locations"
          >
            <MdChevronLeft />
            <Typography variant="overline">{CONST.OUR_PCP_LOCATIONS}</Typography>
          </IconButton>
        </CardActions>

        <CardContent sx={{ p: "0px 16px 0px 16px", overflow: "auto" }}>
          <Grid item xs={12}>
            <Box
              sx={{
                pb: 2,
                height: "30vh",
                width: "100%",
              }}
            >
              {practice && (
                <GoogleMapReact
                  defaultCenter={
                        {
                          lat: parseFloat(practice.lat),
                          lng: parseFloat(practice.lng)
                        }
                  }
                  defaultZoom={14}
                  bootstrapURLKeys={{ key: `${patient.google_maps_api_key}` }}
                  yesIWantToUseGoogleMapApiInternals
                >
                  {practice && (
                    <MapMarker
                      selectable={false}
                      showPcps={true}
                      selectHandler
                      lat={practice.lat}
                      lng={practice.lng}
                      practice={{ ...practice }}
                    />
                  )}
                </GoogleMapReact>
              )}
              {!practice && (
                <Box textAlign="center" fontWeight="600">
                  {CONST.NO_MAP_DATA}
                </Box>
              )}
            </Box>
            <Box p={2}>
              <PcpLocationItem practice={practice} />
              <Box my={2}>
                <Typography variant="overline">{CONST.DETAILS}</Typography>
                <ul className="details">
                  {practice.ages_served && (
                    <li>
                      <Typography>{practice.ages_served}</Typography>
                    </li>
                  )}
                  {practice.spanish_available && (
                    <li>
                      <Typography>{CONST.SPANISH_AVAILABLE}</Typography>
                    </li>
                  )}
                  {practice.chinese_available && (
                    <li>
                      <Typography>{CONST.CHINESE_AVAILABLE}</Typography>
                    </li>
                  )}
                  {practice.translation_available && (
                    <li>
                      <Typography>{CONST.TRANSLATION_AVAILABLE}</Typography>
                    </li>
                  )}
                </ul>
              </Box>
              <Box mt={1.5}>
                <Typography variant="overline">
                  {!!practice.electable_pcps.length > 0
                    ? "PCPs at this location"
                    : "No available PCPs at this location"}
                </Typography>
              </Box>
              {!!practice.electable_pcps.length > 0 &&
                practice.electable_pcps.map((pcp) => (
                  <PcpListItem pcp={pcp} key={pcp.id} selectPcp={() => {
                    history.push("/patient_portal/dashboard");
                    props.selectPcp(pcp);
                  }} />
                ))}
            </Box>
          </Grid>
        </CardContent>
      </Grid>
    </Grid>
  );
}
